import { colors } from '../theme';

// Shared style + copy table for premises classifications. Lives in
// its own module (not next to the React component) so consumers like
// DepletionsGeographicBreakdown can grab the color palette without
// hitting React Fast Refresh's "only export components" rule.

export interface PremisesStyle {
  label: string;
  color: string;
  bg: string;
  border: string;
  description: string;
}

export const PREMISES_STYLE: Record<string, PremisesStyle> = {
  ON: {
    label: 'ON',
    color: colors.success,
    bg: `${colors.success}14`,
    border: `${colors.success}40`,
    description: 'On-premise — bars, restaurants, lounges.',
  },
  OFF: {
    label: 'OFF',
    color: colors.info,
    bg: `${colors.info}14`,
    border: `${colors.info}40`,
    description: 'Off-premise — liquor stores, retail.',
  },
  NA: {
    label: 'NA',
    color: colors.warning,
    bg: `${colors.warning}14`,
    border: `${colors.warning}40`,
    description: 'Broker classified as not-applicable (clubs, military, lounges, etc.).',
  },
  ONLINE: {
    label: 'ONLINE',
    color: '#7c5cc4',
    bg: '#7c5cc414',
    border: '#7c5cc440',
    description: 'E-commerce / online retailer — a distinct direct-to-consumer channel.',
  },
};
